import React from 'react';
import {
  CardInfo,
  CardInfoItem,
  CardInfoValueType,
  FlexItem,
  H3,
} from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { Resources } from '@erecruit/types';

import { DATE_FORMAT } from '../../../../constants';

const { FormattedMessage } = Intl;

export default ({ data }: { data: Resources.MatchSchedule }) => {
  const {
    estimatedEndDate,
    startDate,
    workHours,
    estimatedHoursPerWeek,
  } = data;

  return (
    <FlexItem>
      <CardInfo
        title={
          <H3 align="center">
            <FormattedMessage id={messageIds.vms.matchRecord.schedule.title} />
          </H3>
        }
        config={{ dateFormat: DATE_FORMAT }}
      >
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.matchRecord.schedule.startDate}
            />
          }
          type={CardInfoValueType.Date}
          value={startDate}
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.matchRecord.schedule.estimatedEndDate}
            />
          }
          type={CardInfoValueType.Date}
          value={estimatedEndDate}
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.matchRecord.schedule.workHours}
            />
          }
          type={CardInfoValueType.Text}
          value={workHours}
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.matchRecord.schedule.estimatedHoursPerWeek}
            />
          }
          type={CardInfoValueType.Text}
          value={estimatedHoursPerWeek}
        />
      </CardInfo>
    </FlexItem>
  );
};
